import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import * as React from 'react';
import styled from 'styled-components';
import { ___p } from '@ifixit/localize';
var breakpointSm = '@media screen and (max-width: 650px)';
var BarContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   display: flex;\n   align-items: center;\n   margin: 8px 0;\n\n   ", " {\n      justify-content: space-between;\n   }\n"])), breakpointSm);
var Bar = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   flex: 1;\n   position: relative;\n   height: 8px;\n   max-width: 120px;\n   margin: 0 8px;\n   border-radius: 8px;\n   overflow: hidden;\n   background: #e3e8ec;\n\n   ", " {\n      max-width: none;\n   }\n"])), breakpointSm);
var InnerBar = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   position: absolute;\n   height: 100%;\n   left: 0;\n   width: ", "%;\n   background: #0b77e9;\n   border-radius: 8px;\n"])), function (props) {
  return props.value / props.max * 100;
});
var BarText = styled.h3(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n   font-size: 13px;\n   font-weight: normal;\n   min-width: 32px;\n   text-align: left;\n   margin: 0;\n"])));

var ReviewBar = function ReviewBar(_ref) {
  var count = _ref.count,
      numReviews = _ref.numReviews,
      index = _ref.index;
  var percentage = numReviews === 0 ? 0 : Math.round(count / numReviews * 100);
  return /*#__PURE__*/React.createElement(BarContainer, null, /*#__PURE__*/React.createElement(BarText, {
    active: count > 0
  }, ___p(index, '1 star', '%1 star', index)), /*#__PURE__*/React.createElement(Bar, null, /*#__PURE__*/React.createElement(InnerBar, {
    value: count,
    max: numReviews
  })), /*#__PURE__*/React.createElement(BarText, {
    active: count > 0
  }, "".concat(percentage, "%")));
};

export default ReviewBar;